import { Backdrop, Button, Fade, Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Animation_Error_animation from "./ServicesOperationComponent/Helper/Animation_Error";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  border: "1px solid #FED7D7",
  borderTop: "5px solid #D32F2F",
};

export default function ErrorModal({ open, message, message2, handleClose }) {
  const handleCloseModal = (event) => {
    event.stopPropagation(); // Detiene la propagación del evento
    handleClose(event); // Llama a la función original de cerrar el modal
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleCloseModal}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Animation_Error_animation color="#D32F2F" />

          <Typography
            id="transition-modal-description"
            sx={{
              mt: 2,
              textAlign: "center",
              color: "#1A202C",
              fontWeight: 600,
              fontSize: "18px",
            }}
          >
            {message}
          </Typography>
          <Typography
            id="transition-modal-description2"
            sx={{
              mt: 2,
              textAlign: "center",
              color: "#718096",
              fontSize: "13px",
              fontWeight: 400,
            }}
          >
            {message2}
          </Typography>

          <Button
            type="submit"
            variant="contained"
            onClick={(e) => handleCloseModal(e)}
            sx={{
              marginTop: "20px",
              backgroundColor: "#002878",
              "&:hover": {
                backgroundColor: "#002878",
              },
              color: "white",
            }}
          >
            Aceptar
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
}
